import { Avatar as MuiAvatar, AvatarProps as MuiAvatarProps } from '@mui/material'
import clsx from 'clsx'
import { FC, ReactNode } from 'react'
import { AvatarSize } from './types'

export type AvatarProps = {
    size?: AvatarSize
    /**
     * Url of the image. Alternatively, pass in text or icon as a child.
     */
    src?: string
    /**
     * If the src prop is provided, alt attribute for the image.
     */
    alt?: string
    children?: ReactNode

    /* Use with care. Added to make the component usable with Chip, which
     * clones the avatar and sets its className prop.
     */
    className?: string
    sx?: MuiAvatarProps['sx']
}

const Avatar: FC<AvatarProps> = ({ alt, src, size = 'large', sx, className, children }) => {
    return (
        <MuiAvatar alt={alt} src={src} className={clsx(`DsAvatar-size-${size}`, className)} sx={sx}>
            {children}
        </MuiAvatar>
    )
}

export default Avatar
